<template>
  <div class="page-search">
    <div class="tabs-container">
      <tab-selector class="tabs"
                    v-bind:tabs-data="filters"
                    v-on:change="onTabChanged">
      </tab-selector>
    </div>
    <page-loader v-if="!orders"></page-loader>
    <div class="row">
      <div class="small-12 column">
        <h2 class="section-title">{{$t('search-result.orders-count', {count: orders.length})}}</h2>
      </div>
    </div>
    <div class="row">
      <div class="small-12 column">
        <div class="filters">
          <span v-if="filterKeywords.length > 0"><strong>{{$t('search.label.keywords')}}</strong>&nbsp;"{{filterKeywords}}";</span>
          <span v-if="filterStatus.length > 0"><strong>{{$t('search.label.status')}}</strong>&nbsp;"{{filterStatus}}";</span>
          <span v-if="filterFlags.length > 0"><strong>{{$t('search.label.notification')}}</strong>&nbsp;"{{filterFlags}}";</span>
          <span v-if="filterPeriod.length > 0"><strong>{{$t('search.label.period')}}</strong>&nbsp;"{{filterPeriod}}"</span>
        </div>
      </div>
    </div>

    <ul class="order-list">
      <li is="order-list-item"
          v-for="order in orders"
          :key="order.number"
          :order-number="order.number"
          :order-ref="order.ref"
          :order-date="order.date"
          :order-status="order.status"
          :delivery-date-from="order.delivery.fromDate"
          :delivery-date-to="order.delivery.toDate"
          :delivery-date-is-different="order.delivery.dateIsDifferent"
          :delivery-date-has-changed="order.delivery.dateHasChanged">
      </li>
    </ul>
  </div>
</template>

<script>
  import _ from 'lodash'
  import TabSelector from 'components/TabSelector'
  import OrderListItem from 'components/OrderListItem'
  import PageLoader from 'components/PageLoader'

  export default {
    name: 'page-search',
    computed: {
      filters () {
        return this.$store.state.filters
      },
      orders () {
        return _.orderBy(this.$store.getters.filteredOrders, 'number', 'desc')
      },
      filterKeywords () {
        return this.$store.state.searchConfig.keywords
      },
      filterFlags () {
        var flagsOld = this.$store.state.searchConfig.flags
        var flags = flagsOld.slice()
        for (var i = 0; i < flags.length; i++) {
          flags[i] = this.$t('search.button.notification.' + flags[i])
        }
        return flags.length > 0 ? flags.join(', ') : ''
      },
      filterStatus () {
        var statusOld = this.$store.state.searchConfig.status
        var status = statusOld.slice()
        for (var i = 0; i < status.length; i++) {
          status[i] = this.$t('search.button.status.' + status[i])
        }
        return status.length > 0 ? status.join(', ') : 'all'
      },
      filterPeriod () {
        var periodOld = this.$store.state.searchConfig.period
        var period = periodOld.slice()
        for (var i = 0; i < period.length; i++) {
          period[i] = this.$t('search.button.period.' + period[i])
        }
        return period.length > 0 ? period[0] : ''
      }
    },
    methods: {
      onTabChanged (tabId) {
        this.$store.commit('changeCurrentFilter', tabId)
      }
    },
    components: {
      'order-list-item': OrderListItem,
      'tab-selector': TabSelector,
      'page-loader': PageLoader
    },
    beforeCreate () {
      this.$store.dispatch('searchOrders', this.$store.state.searchConfig)
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  .page-search {
    ul.order-list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .tabs-container {
      padding: 19px 0;
      text-align: center;

      .tabs {
        margin: 0 auto;
      }
    }
    h2.section-title {
      margin: 24px 0 6px 0;
    }

    .filters {
      margin-bottom: 15px;
    }

    ul.order-list {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// PageOrderList.vue?4015831a